import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const GoogleAuthButton = ({ className, children = 'Continue with Google' }) => {
  const handleGoogleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Pass window.location.origin explicitly so backend builds the correct redirect_uri
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

    if (googleClientId) {
      const origin = encodeURIComponent(window.location.origin);
      window.location.href = `${BACKEND_URL}/api/auth/google?origin=${origin}`;
    } else {
      // Fallback: Emergent-managed auth (preview env without custom Google credentials)
      const redirectUrl = window.location.origin + '/auth/callback';
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    }
  };

  return (
    <Button
      onClick={handleGoogleAuth}
      className={className || "w-full bg-white text-black hover:bg-gray-100 font-bold h-12 rounded-full flex items-center justify-center space-x-3"}
      data-testid="google-auth-button"
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
      <span>{children}</span>
    </Button>
  );
};